/**
 * Common Control Group Exports
 *
 * Main export file for common control group utilities, types, and constants
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

// Export types
export type {
	BaseControlGroupProps,
	BaseEnabledControls,
	PresetOption,
	RangeSettings,
	ResponsiveAttributes,
	ResponsiveBreakpoint,
	SelectOption,
	UnitOption,
} from './types';

// Export constants
export {
	BREAKPOINT_LABELS,
	COMMON_PRESET_SIZES,
	COMMON_UNITS,
	DEFAULT_RANGE_SETTINGS,
	EXTENDED_UNITS,
	RESET_LABELS,
	RESPONSIVE_BREAKPOINTS,
	VALID_CSS_UNITS,
} from './constants';

// Export utilities
export {
	deviceTypeToBreakpoint,
	formatValueWithUnit,
	getResponsiveValues,
	hasAnyResponsiveValues,
	hasNonEmptyValues,
	isValidCSSValue,
	parseValueWithUnit,
	resetResponsiveAttributes,
	stylesToCSS,
	updateResponsiveProperty,
	updateResponsiveValues,
} from './utils';

// Export responsive utilities
export {
	generateMediaQuery,
	generateResponsiveCSS,
	getMediaQuery,
} from './responsive';
